import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './RouteAdmin';

import Home from '~/pages/admin/Home';
import Companies from '~/pages/admin/Companies';
import CompanyForm from '~/pages/admin/CompanyForm';
import Payments from '~/pages/admin/Payments';

const CompanyRoutes: React.FC = () => {
  return (
    <Switch>
      {/* DASHBOARD */}
      <Route path="/" exact component={Home} isPrivate />

      <Route path="/companies" exact component={Companies} isPrivate />
      <Route path="/companies/edit/:id" component={CompanyForm} isPrivate />

      <Route path="/payments" exact component={Payments} isPrivate />

      <Route path="*" component={Home} />
    </Switch>
  );
};

export default CompanyRoutes;
